import React, { FunctionComponent } from "react";
import { IAlbum } from "../../../../hooks/albums";
import { List, useTheme } from "@mui/material";
import styles from "./styles.module.scss";
import { AlbumIdentifierItem } from "../AlbumIdentifierItem";
import { PiperDivider } from "../../../PiperDivider";
import { IAlbumIdentifier } from "../../../../hooks/albumIdentifiers";

export const AlbumIdentifiersTable: FunctionComponent<IAlbumIdentifiersTableProps> = ({
  isPublic,
  album,
  onModify,
  onMoveDown,
  onMoveUp,
  onDelete
}) => {
  const theme = useTheme();
  return (
    <List className={styles.list}>
      {album.albumIdentifiers?.map((albumIdentifier, index) => (
        <div key={index}>
          <AlbumIdentifierItem
            isPublic={isPublic}
            albumIdentifier={albumIdentifier}
            onModify={() => onModify(albumIdentifier)}
            canModify
            canMoveDown={index < album.albumIdentifiers?.length - 1}
            canMoveUp={index > 0}
            onMoveDown={() => onMoveDown(index)}
            onMoveUp={() => onMoveUp(index)}
            onDelete={() => onDelete(albumIdentifier)}
          />
          {index < album.albumIdentifiers?.length - 1 && (
            <PiperDivider color={theme.palette.background.paper} />
          )}
        </div>
      ))}
    </List>
  );
};

export interface IAlbumIdentifiersTableProps {
  isPublic: boolean;
  album: IAlbum;
  onModify: (albumIdentifier: IAlbumIdentifier) => void;
  onMoveDown: (index: number) => void;
  onMoveUp: (index: number) => void;
  onDelete: (albumIdentifier: IAlbumIdentifier) => void;
}
